// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6404":"8d206fa5","8420":"8d206fa5"}[chunkId] + ".chunk.css";
};